import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable } from 'components';
import { ModeratorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import { WhiteImage } from 'assets/img';
import { LocationIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
	modules: any;
	document_types: any;
	phonecodes: any;
}

class CreateModerator extends React.Component<Props> {

	state = {
		modules: [],
		form: {
			name: '',
	        email: '',
	        password: '',
	        document: '',
	        document_type_id: this.props.document_types.length > 0 ? this.props.document_types[0].id : '',
	        phonecode_id: this.props.phonecodes.length > 0 ? this.props.phonecodes[0].id : '',
	        phone: '',
	        address: ''
		}
	}

	componentDidMount() {
		this.setState({
			modules: Globals.clone(this.props.modules),
		},() => {
			if (this.props.item) {
				this.setState({
					form: {
						...this.state.form,
						name: this.props.item?.name || '',
						email: this.props.item?.email || '',
						document_type_id: this.props.item?.document_type_id || (this.props.document_types.length > 0 ? this.props.document_types[0].id : ''),
						phonecode_id: this.props.item?.phonecode_id || (this.props.phonecodes.length > 0 ? this.props.phonecodes[0].id : ''),
						phone: this.props.item?.phone || '',
						document: this.props.item?.document || '',
						address: this.props.item?.address || ''
					},
					modules: Globals.clone(this.props.modules).map((i: any) => {
						if (this.props.item?.module_permissions) {
							const permission = this.props.item?.module_permissions.find((item: any) => item.module_id == i.id);
							if (permission) {
								i.read = permission.read == true;
								i.write = permission.write == true;
								i.delete = permission.delete == true;
							}
						}
						return i;
					})
				});
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await ModeratorService.admin.update({
				user_id: this.props.item?.id,
				...this.state.form,
				module_permissions: this.state.modules.map((i: any) => {
					return {
						module_id: i.id,
						read: i.read,
						write: i.write,
						delete: i.delete
					}
				})
			});
			Globals.showSuccess("Se ha modificado el moderador correctamente");
			Socket.emit(SocketEvents.UPDATE_USER,{
				user_id: this.props.item?.id
			});
			this.props.onClose();
		}
		else {
			await ModeratorService.admin.create({
				...this.state.form,
				module_permissions: this.state.modules.map((i: any) => {
					return {
						module_id: i.id,
						read: i.read,
						write: i.write,
						delete: i.delete
					}
				})
			});
			Globals.showSuccess("Se ha creado el moderador correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	checkModule = (index: number, target: string) => {
		let modules: any = [...this.state.modules];
		if (target == 'active') {
			if (modules[index]['write'] && modules[index]['read'] && modules[index]['delete']) {
				modules[index]['read'] = false;
				modules[index]['write'] = false;
				modules[index]['delete'] = false;
			}
			else {
				modules[index]['read'] = true;
				modules[index]['write'] = true;
				modules[index]['delete'] = true;
			}
		}
		else {
			modules[index][target] = !modules[index][target];
		}
		this.setState({
			modules
		});
	}
	
	render() {
		return (
			<div id="modal-create-moderator">
				<form className="row" onSubmit={ this.submit }>
					<div className="col-md-6">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							label="Nombre"
							onChange={ this.change } />
					</div>
					<div className="col-md-6">
						<Input
							color="white"
							value={ this.state.form.email }
							name="email" 
							label="Correo Electrónico"
							onChange={ this.change } />
					</div>
					<div className="col-md-6">
						<div className="container-select">
							<p className="label">Dirección</p>
							<div>
								<div className="container-icon">
									<img src={ LocationIcon } />
								</div>
								<Input
									color="white"
									value={ this.state.form.address }
									name="address" 
									placeholder="Dirección"
									onChange={ this.change } />
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<div className="container-select">
							<p className="label">Tipo de Documento</p>
							<div>
								<Select
									className="document_type"
									name="document_type_id"
									onChange={ this.change }
									value={ this.state.form.document_type_id }
									options={ this.props.document_types.map((i: any) => {
										return {
											value: i.id,
											label: i.name
										}
									}) } />
								<Input
									type="number"
									color="white"
									value={ this.state.form.document }
									name="document" 
									placeholder="Documento"
									onChange={ this.change } />
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<div className="container-select">
							<p className="label">Teléfono</p>
							<div>
								<Select
									name="phonecode_id"
									onChange={ this.change }
									value={ this.state.form.phonecode_id }
									options={ this.props.phonecodes.map((i: any) => {
										return {
											value: i.id,
											label: i.name
										}
									}) } />
								<Input
									type="number"
									color="white"
									value={ this.state.form.phone }
									name="phone" 
									placeholder="Teléfono"
									onChange={ this.change } />
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<Input
							type="password"
							color="white"
							value={ this.state.form.password }
							name="password" 
							label={ this.props.item != null ? "Cambiar Contraseña (Opcional)" : "Contraseña" }
							onChange={ this.change } />
					</div>
					<h3>Módulos Autorizados</h3>
					<table>
						<thead>
							<tr>
								<th style={{ paddingLeft: '10px' }}></th>
								<th className="text-center">Ver</th>
								<th className="text-center">Escribir</th>
								<th className="text-center" style={{ paddingRight: '10px' }}>Eliminar</th>
							</tr>
						</thead>
						<tbody>
							{
								(this.state.modules || []).map((item: any, index: number) => {
									return (
										<tr>
											<td style={{ paddingLeft: '10px' }}>
												<div className="td-check">
													<CheckboxTable
														size="small" 
														active={ item.read && item.write && item.delete } 
														onClick={ () => this.checkModule(index,'active') } />
													<p>{ item.name }</p>
												</div>
											</td>
											<td className="td-center">
												<CheckboxTable 
													size="small" 
													active={ item.read } 
													onClick={ () => this.checkModule(index,'read') } />
											</td>
											<td className="td-center">
												<CheckboxTable 
													size="small" 
													active={ item.write } 
													onClick={ () => this.checkModule(index,'write') } />
											</td>
											<td className="td-center" style={{ paddingRight: '10px' }}>
												<CheckboxTable 
													size="small" 
													active={ item.delete } 
													onClick={ () => this.checkModule(index,'delete') } />
											</td>
										</tr>
									)
								})
							}
						</tbody>
					</table>
					<div className="col-12">
						<div className="row row-buttons">
							<div className="col-md-6 text-center">
								<Button type="button" onClick={ () => this.props.onClose() }>
									Cerrar
								</Button>
							</div>
							<div className="col-md-6 text-center">
								<Button type="submit">
									Guardar
								</Button>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateModerator;